const STORAGE_KEY = 'tolbert_pending_giveaway_entry_v1';
const PENDING_ENTRY_TTL_MS = 24 * 60 * 60 * 1000; // 24 hours

const normalizeSlots = (slots) => {
  if (!Array.isArray(slots)) return [];
  return slots
    .map((slot) => Number(slot))
    .filter((slot) => Number.isFinite(slot) && slot > 0);
};

export const readPendingGiveawayEntry = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return null;

    const giveawayId = parsed.giveawayId ? String(parsed.giveawayId) : '';
    const slots = normalizeSlots(parsed.slots);
    if (!giveawayId || slots.length === 0) return null;

    const createdAt = typeof parsed.createdAt === 'number' ? parsed.createdAt : null;
    if (createdAt && Date.now() - createdAt > PENDING_ENTRY_TTL_MS) {
      try {
        localStorage.removeItem(STORAGE_KEY);
      } catch (_err) {
        // Ignore storage errors
      }
      return null;
    }

    return {
      giveawayId,
      slots,
      tier: parsed.tier ? String(parsed.tier) : null,
      userId: parsed.userId ? String(parsed.userId) : null,
      giveawayTitle: parsed.giveawayTitle ? String(parsed.giveawayTitle) : null,
      createdAt: parsed.createdAt || null,
      source: parsed.source ? String(parsed.source) : null,
    };
  } catch (_err) {
    return null;
  }
};

export const writePendingGiveawayEntry = (entry) => {
  if (!entry || typeof entry !== 'object') return false;
  const giveawayId = entry.giveawayId ? String(entry.giveawayId) : '';
  const slots = normalizeSlots(entry.slots);
  if (!giveawayId || slots.length === 0) return false;

  const payload = {
    giveawayId,
    slots,
    tier: entry.tier ? String(entry.tier) : null,
    userId: entry.userId ? String(entry.userId) : null,
    giveawayTitle: entry.giveawayTitle ? String(entry.giveawayTitle) : null,
    createdAt: entry.createdAt || Date.now(),
    source: entry.source || 'insufficient-credits',
  };

  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    return true;
  } catch (_err) {
    return false;
  }
};

export const clearPendingGiveawayEntry = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (_err) {
    // Ignore storage errors
  }
};
